import {fromEvent} from 'rxjs';

import {delay, tap} from 'rxjs/operators';
import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  private listening = false;
  private globalClick;

  @Output() clickOutside: EventEmitter<object> = new EventEmitter();

  constructor(private _elRef: ElementRef) {}

  ngOnInit() {
    this.globalClick = fromEvent(document, 'click')
      .pipe(
        delay(1),
        tap(() => {
          this.listening = true;
        })
      )
      .subscribe((event: MouseEvent) => {
        this.onGlobalClick(event);
      });
  }

  ngOnDestroy() {
    this.globalClick.unsubscribe();
  }

  onGlobalClick(event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (this.isDescendant(this._elRef.nativeElement, event.target) === false) {
        event.preventDefault();
        this.clickOutside.emit({
          target: event.target || null,
          value: false
        });
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;

    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }

    return false;
  }
}
